import decode from 'jwt-decode';

import DataService from './DataService';

const TOKEN_KEY = 'Sponda-App';

export default class AuthService extends DataService {
	// Initializing important variables
	constructor() {
		super();

		this.login = this.login.bind(this)
		this.getProfile = this.getProfile.bind(this)
	}

	login(username, password) {
		// Get a token from api server using the fetch api
		return this.fetch('/login/', {
			method: 'POST',
			body: JSON.stringify({
				username,
				password
			})
		}).then(response => {
			this.setToken(response.result.user.token); // Setting the token in localStorage
			return Promise.resolve(response);
		})
	}

	setToken(idToken) {
		// Saves user token to localStorage
		localStorage.setItem(TOKEN_KEY, idToken);
	}

	logout() {
		// Clear user token and profile data from localStorage
		localStorage.removeItem(TOKEN_KEY);
	}

	getProfile() {
		// Using jwt-decode npm package to decode the token
		return decode(this.getToken());
	}

	getUser() {
		return this.fetch('/users/current/', {
			method: 'GET',
		});
	}
}
